/* Todaysunny 3.1. Native product-info/form remain the source of variant and cart data. */
(() => {
  'use strict';
  const core = window.TSCommerce;
  if (!core) return;
  const text = (key, fallback) => window.tsStrings?.[key] || fallback;
  const listen = (name, callback) => typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' ? subscribe(PUB_SUB_EVENTS[name], callback) : () => {};
  const pickerOf = (info) => Array.from(info?.querySelectorAll('variant-selects') || []).find((node) => node.style.display !== 'none');
  const selectedVariant = (info) => {
    try { return JSON.parse(pickerOf(info)?.querySelector('[data-selected-variant]')?.textContent || 'null'); }
    catch (_) { return null; }
  };

  if (!customElements.get('ts-amazon-link')) customElements.define('ts-amazon-link', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      this.productInfo = this.closest('product-info');
      this.link = this.querySelector('a');
      if (!this.link) return;
      this.setURL(this.link.getAttribute('href'));
      this.productInfo?.addEventListener('change', (event) => {
        if (event.target.matches('input[name="id"]') && !event.target.value) this.setURL('');
      }, {signal:this.abort.signal});
      this.offSelection = listen('optionValueSelectionChange', ({ data }) => {
        if (this.productInfo?.contains(data?.event?.target)) this.setURL('');
      });
      this.offVariant = listen('variantChange', ({ data }) => {
        if (!core.matchesProductEvent(this.productInfo, data)) return;
        if (!data.variant) { this.setURL(''); return; }
        const source = Array.from(data.html?.querySelectorAll('ts-amazon-link') || []).find((element) => element.dataset.product === this.dataset.product);
        this.dataset.variant = String(data.variant.id || '');
        this.setURL(source?.querySelector('a')?.getAttribute('href'));
        this.dataset.linkScope = source?.dataset.linkScope || 'product';
        const optionsNote = this.querySelector('[data-ts-amazon-options-note]');
        if (optionsNote) optionsNote.hidden = this.dataset.linkScope === 'variant';
      });
    }
    setURL(value) {
      const url = core.validAmazonURL(value);
      this.hidden = !url;
      if (url) this.link.setAttribute('href', url); else this.link.removeAttribute('href');
    }
    disconnectedCallback() { this.abort?.abort(); this.offSelection?.(); this.offVariant?.(); }
  });

  if (!customElements.get('ts-purchase-guard')) customElements.define('ts-purchase-guard', class extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      if (!this.info || this.dataset.required !== 'true') return;
      this.info.tsSizeGuard = this;
      this.confirmedValue = null; this.busy = false; this.failed = false;
      this.variant = selectedVariant(this.info);
      this.abort = new AbortController();
      const options = { capture:true, signal:this.abort.signal };
      this.info.addEventListener('click', (event) => this.onClick(event), options);
      this.info.addEventListener('change', (event) => this.onChange(event), options);
      this.info.addEventListener('submit', (event) => {
        if (event.target.matches('form[data-type="add-to-cart-form"]') && !this.allowSubmit()) {
          event.preventDefault(); event.stopImmediatePropagation();
        }
      }, options);
      this.info.addEventListener('ts:variant-error', () => { this.busy = false; this.failed = true; this.update(); }, { signal:this.abort.signal });
      this.offSelection = listen('optionValueSelectionChange', ({data}) => {
        if (!this.info.contains(data?.event?.target)) return;
        this.busy = true; this.failed = false; this.update();
      });
      this.offVariant = listen('variantChange', ({data}) => {
        if (!core.matchesProductEvent(this.info, data)) return;
        this.busy = false; this.failed = false; this.variant = data.variant;
        const position = Number(this.sizeGroup?.dataset.tsOptionPosition || 0) - 1;
        if (this.confirmedValue && data.variant && String(data.variant.options?.[position]) !== this.confirmedValue) this.confirmedValue = null;
        this.update();
      });
      this.update();
    }
    get sizeGroup() { return pickerOf(this.info)?.querySelector('[data-ts-option-role="size"]'); }
    get required() { return !!this.sizeGroup; }
    get pending() { return this.required && !this.confirmedValue; }
    get button() { return this.info?.querySelector('.product-form__submit'); }
    onClick(event) {
      const group = event.target.closest('[data-ts-option-role]');
      if (group?.dataset.tsOptionRole === 'size' && event.target.closest('[data-ts-confirm-size]')) {
        const select = group.querySelector('select');
        if (select) {
          this.confirmedValue = String(select.value);
          const index = Number(group.dataset.tsOptionPosition) - 1;
          if (this.failed || String(this.variant?.options?.[index]) !== this.confirmedValue) {
            this.busy = true; this.failed = false; select.dispatchEvent(new Event('change', {bubbles:true}));
          }
          this.update(); select.focus({preventScroll:true});
        }
      }
      if (group && event.target.matches('input[type="radio"]')) {
        if (group.dataset.tsOptionRole === 'size') {
          this.confirmedValue = String(event.target.value);
          const index = Number(group.dataset.tsOptionPosition) - 1;
          if (String(this.variant?.options?.[index]) !== this.confirmedValue) this.busy = true;
          if (this.failed) { this.failed = false; event.target.dispatchEvent(new Event('change', {bubbles:true})); }
          this.update();
        } else if (group.dataset.tsOptionRole === 'color' && this.dataset.resetColor === 'true') {
          const index = Number(group.dataset.tsOptionPosition) - 1;
          if (String(this.variant?.options?.[index]) !== String(event.target.value)) { this.confirmedValue = null; this.update(); }
        }
      }
      if (event.target.closest('.product-form__submit, [data-ts-buy-now]') && !this.allowSubmit()) {
        event.preventDefault(); event.stopImmediatePropagation();
      }
    }
    onChange(event) {
      const group = event.target.closest('[data-ts-option-role]');
      if (!group) return;
      if (group.dataset.tsOptionRole === 'size') this.confirmedValue = String(event.target.value);
      else if (group.dataset.tsOptionRole === 'color' && this.dataset.resetColor === 'true') this.confirmedValue = null;
      this.update();
    }
    allowSubmit() {
      if (this.pending) { this.prompt(); return false; }
      if (this.busy || this.failed) return false;
      if (this.required && (!this.variant || !this.variant.available)) return false;
      return true;
    }
    prompt() {
      const group = this.sizeGroup;
      if (!group) return;
      group.setAttribute('data-ts-needs-attention', 'true');
      group.scrollIntoView({ behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center' });
      const target = group.querySelector('input:not(.disabled), select, input');
      target?.focus({preventScroll:true});
      this.update();
    }
    update() {
      if (!this.info) return;
      this.info.dataset.tsSizePending = this.pending ? 'true' : 'false';
      this.info.dataset.tsSelectionBusy = this.busy ? 'true' : 'false';
      const message = pickerOf(this.info)?.querySelector('[data-ts-size-message]');
      if (message) {
        message.hidden = !this.pending;
        if (message.textContent !== text('chooseSizeHelp','Select your size before adding to your bag.')) message.textContent = text('chooseSizeHelp','Select your size before adding to your bag.');
      }
      if (!this.pending) this.sizeGroup?.removeAttribute('data-ts-needs-attention');
      this.sizeGroup?.querySelectorAll('[data-ts-confirm-size]').forEach((button) => { button.hidden = !this.pending; });
      const button = this.button;
      if (button && !button.disabled && !this.busy) {
        const label = button.querySelector('span');
        const content = this.pending ? text('chooseSize','Choose your size') : (window.variantStrings?.addToCart || text('addToCart','Add to bag'));
        if (label && label.textContent.trim() !== content) label.textContent = content;
      }
      const directButton = this.info.querySelector('[data-ts-buy-now]');
      if (directButton && !directButton.disabled && !this.busy) {
        const directLabel = directButton.querySelector('span');
        const directContent = this.pending ? text('chooseSize','Choose your size') : text('buyNow','Buy now');
        if (directLabel && directLabel.textContent.trim() !== directContent) directLabel.textContent = directContent;
      }
      this.info.querySelectorAll('.shopify-payment-button').forEach((element) => { element.hidden = this.pending || this.busy || this.failed || (this.required && !this.variant?.available); });
      this.info.dispatchEvent(new CustomEvent('ts:purchase-state', { bubbles:false }));
    }
    disconnectedCallback() {
      this.abort?.abort(); this.offSelection?.(); this.offVariant?.();
      if (this.info?.tsSizeGuard === this) delete this.info.tsSizeGuard;
    }
  });

  if (!customElements.get('ts-gallery-filter')) customElements.define('ts-gallery-filter', class extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info'); this.gallery = this.closest('media-gallery');
      if (!this.info || !this.gallery) return;
      this.readData(this);
      this.apply();
      this.offVariant = listen('variantChange', ({data}) => {
        if (!core.matchesProductEvent(this.info, data)) return;
        const source = data.html?.querySelector('ts-gallery-filter');
        if (source) this.readData(source);
        this.apply(data.variant?.featured_media?.id);
      });
    }
    readData(source) {
      try { this.data = JSON.parse(source.querySelector('[data-ts-gallery-json]')?.textContent || '{}'); }
      catch (_) { this.data = {mode:'off',media:[]}; }
    }
    apply(featuredId) {
      if (!this.data?.media?.length) return;
      const colorGroup = pickerOf(this.info)?.querySelector('[data-ts-option-role="color"]');
      const color = colorGroup?.querySelector('input:checked')?.value || colorGroup?.querySelector('select')?.value || this.data.selectedColor;
      const ids = core.visibleMediaIds(this.data, color); const allowed = new Set(ids);
      const setVisible = (element, id) => {
        const hidden = !allowed.has(String(id));
        element.hidden = hidden;
        element.toggleAttribute('data-ts-media-hidden', hidden);
        if (hidden) { element.classList.remove('is-active'); element.querySelectorAll('video').forEach((video) => video.pause()); }
      };
      const slides = Array.from(this.gallery.querySelectorAll('li[data-media-id]'));
      slides.forEach((element) => setVisible(element, element.dataset.tsMediaId || element.dataset.mediaId.split('-').pop()));
      this.gallery.querySelectorAll('li[data-target]').forEach((element) => setVisible(element, element.dataset.tsMediaId || element.dataset.target.split('-').pop()));
      // The native media modal is part of this product-info, not a global modal.
      this.info.querySelectorAll('product-modal .product-media-modal__content > [data-media-id]').forEach((element) => setVisible(element, element.dataset.mediaId));
      const visible = slides.filter((slide) => !slide.hidden);
      let active = visible.find((slide) => (slide.dataset.tsMediaId || slide.dataset.mediaId.split('-').pop()) === String(featuredId || this.data.featuredId));
      active ||= visible.find((slide) => slide.classList.contains('is-active')) || visible[0];
      if (active) {
        const activeId = active.dataset.mediaId;
        slides.forEach((slide) => slide.classList.toggle('is-active', slide === active));
        const thumbnail = this.gallery.querySelector(`[data-target="${CSS.escape(activeId)}"]`);
        this.gallery.setActiveThumbnail?.(thumbnail);
        // Scroll the gallery only; changing size must not jump the entire page.
        const track = this.gallery.querySelector('[id^="Slider-Gallery"]');
        if (track && window.matchMedia('(max-width: 749px)').matches) track.scrollTo({left:active.offsetLeft - track.offsetLeft,behavior:'instant'});
      }
      this.gallery.querySelectorAll('slider-component').forEach((slider) => { slider.resetPages?.(); slider.initPages?.(); });
      const total = this.gallery.querySelector('.slider-counter--total'); if (total) total.textContent = String(visible.length);
      this.gallery.dataset.tsVisibleCount = String(visible.length);
    }
    disconnectedCallback() { this.offVariant?.(); }
  });

  if (!customElements.get('ts-sticky-purchase')) customElements.define('ts-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      this.nativeButton = this.info?.querySelector('[data-ts-buy-now]') || this.info?.querySelector('.product-form__submit');
      this.button = this.querySelector('[data-ts-sticky-submit]'); this.detail = this.querySelector('[data-ts-sticky-detail]');
      if (!this.nativeButton || !this.button || this.info.dataset.originalSection) { this.hidden = true; return; }
      this.abort = new AbortController(); const opts = {signal:this.abort.signal};
      this.update = this.update.bind(this);
      this.button.addEventListener('click', () => {
        if (this.info.tsSizeGuard && !this.info.tsSizeGuard.allowSubmit()) return;
        this.update();
        if (!this.button.disabled) { this.submitted = true; this.nativeButton.click(); }
      }, opts);
      ['change','input','ts:purchase-state'].forEach((name) => this.info.addEventListener(name,this.update,opts));
      window.addEventListener('scroll',this.update,{...opts,passive:true}); window.addEventListener('resize',this.update,{...opts,passive:true});
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this.nativeButton,{attributes:true,childList:true,subtree:true,characterData:true});
      this.price = this.info.querySelector('[id^="price-"]');
      if (this.price) this.observer.observe(this.price,{childList:true,subtree:true,characterData:true,attributes:true});
      this.error = this.info.querySelector('.product-form__error-message-wrapper');
      if (this.error) this.observer.observe(this.error,{attributes:true,childList:true,subtree:true,characterData:true});
      this.update();
    }
    update() {
      if (!this.isConnected || !this.nativeButton) return;
      const guard = this.info.tsSizeGuard;
      const busy = guard?.busy || this.nativeButton.getAttribute('aria-disabled') === 'true' || this.nativeButton.classList.contains('loading');
      this.button.disabled = this.nativeButton.disabled || !!busy || !!guard?.failed;
      const label = guard?.pending ? text('chooseSize','Choose your size') : this.nativeButton.querySelector('span')?.textContent.trim() || text('buyNow','Buy now');
      if (this.button.textContent !== label) this.button.textContent = label;
      this.button.setAttribute('aria-busy',busy ? 'true':'false');
      const sale = this.price?.querySelector('.price--on-sale');
      const price = (sale?.querySelector('.price-item--sale') || this.price?.querySelector('.price-item--regular'))?.textContent.trim() || '';
      const values = Array.from(pickerOf(this.info)?.querySelectorAll('input:checked,select') || []).filter((node) => !(guard?.pending && node.closest('[data-ts-option-role="size"]'))).map((node) => node.value);
      const quantity = this.info.querySelector('input[name="quantity"]')?.value || '1';
      const detail = [...values, ...(guard?.pending ? [text('chooseSize','Choose your size')]:[]), `${text('quantity','Qty')} ${quantity}`, price].filter(Boolean).join(' · ');
      if (this.detail && this.detail.textContent !== detail) this.detail.textContent = detail;
      const modalOpen = !!document.querySelector('dialog[open],quick-add-modal[open],.menu-drawer-container[open],cart-drawer.active');
      this.hidden = !window.matchMedia('(max-width: 749px)').matches || this.nativeButton.getBoundingClientRect().bottom >= 0 || modalOpen;
      document.body.classList.toggle('ts-sticky-purchase-visible', !this.hidden);
      if (this.submitted && this.error && !this.error.hidden) { this.submitted = false; this.error.tabIndex = -1; this.error.scrollIntoView({block:'center'}); this.error.focus({preventScroll:true}); }
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); document.body.classList.remove('ts-sticky-purchase-visible'); }
  });
})();
